<template>
  <span class="icon" :class="extraClass" v-html="svg" />
</template>

<script setup>
import iconSvgs from '@/resources/icon-svgs';
import { computed } from 'vue';

const props = defineProps({
  icon: {
    required: true,
  },
});

const svg = computed(() => {
  return iconSvgs(props.icon);
});

const extraClass = computed(() => {
  return props.icon + '-icon';
});
</script>
